<ng-container *transloco="let t">
  <div class="shipping-options">
    <div class="shipping-options__header">
      <label class="ui-label">{{ t('shippingOptions.selectOptionLabel') }}</label>
      @if (providerDisplayName()) {
        <span class="shipping-options__provider">{{ providerDisplayName() }}</span>
      }
    </div>

    @for (group of shippingGroups(); track group.type) {
      <div class="shipping-group" [class.shipping-group--branch]="group.type === 'branch'" [class.shipping-group--home]="group.type === 'home'">
        <div class="shipping-group__header">
          <div class="shipping-group__icon">
            @if (group.type === 'branch') {
              <pxw-icon icon="store" />
            } @else {
              <pxw-icon icon="home" />
            }
          </div>
          <div class="shipping-group__info">
            <strong class="shipping-group__title">{{ group.title }}</strong>
            <span class="shipping-group__subtitle">{{ group.subtitle }}</span>
          </div>
        </div>

        <div class="shipping-group__options">
          @for (option of group.options; track $index) {
            <label class="shipping-option" [class.shipping-option--selected]="selectedOptionInternal() === option.estimate">
              <input
                type="radio"
                name="shippingOption"
                [value]="option.estimate"
                [checked]="selectedOptionInternal() === option.estimate"
                (change)="onOptionSelected(option.estimate)"
                required
              />
              <div class="shipping-option__content">
                <div class="shipping-option__main">
                  <span class="shipping-option__label">{{ option.label }}</span>
                  <span class="shipping-option__time">{{ option.deliveryTime }}</span>
                </div>
                <div class="shipping-option__price-section">
                  <span class="shipping-option__price">{{ option.price | currencyFormat }}</span>
                  @if (option.isBestInGroup) {
                    <span class="shipping-option__badge" [class.shipping-option__badge--save]="group.type === 'branch'" [class.shipping-option__badge--fast]="group.type === 'home'">
                      {{ group.type === 'branch' ? t('shippingOptions.badgeSaveMore') : t('shippingOptions.badgeFaster') }}
                    </span>
                  }
                </div>
              </div>
            </label>
          }
        </div>
      </div>
    }

    @if (isFormSubmitted() && !selectedOptionInternal()) {
      <div class="shipping-options__error">
        {{ t('shippingOptions.required') }}
      </div>
    }
  </div>
</ng-container>
